module.exports = __webpack_public_path__ + "img/active_model.1f162f4a.jpg";